import localforage from 'localforage';
import { CacheEntry, isExpired } from './cacheEntry';

export class CacheService {
  public initialize(): void {
    localforage.config({
      name: 'cache',
      storeName: 'kv-storage',
      driver: localforage.INDEXEDDB,
    });
  }

  public async get<T>(cacheKey: string): Promise<T | undefined> {
    const entry = await localforage.getItem<CacheEntry<T>>(cacheKey);

    if (entry) {
      if (isExpired(entry)) {
        console.log(`Cache expired for ${cacheKey}`);
        await this.delete(cacheKey);
        return undefined;
      }
      return entry.data as T;
    }

    return undefined;
  }

  public async set<T>(cacheKey: string, data: T, ttlMins?: number): Promise<void> {
    const entry = new CacheEntry<T>(data, ttlMins);
    await localforage.setItem(cacheKey, entry);
  }

  public async delete(cacheKey: string): Promise<void> {
    await localforage.removeItem(cacheKey);
  }

  public async clear(): Promise<void> {
    try {
      await localforage.clear();
      window.location.reload();
    } catch (error) {
      console.error('Error during cache clearing process:', error);
      throw error;
    }
  }
}
